import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Article1 from 'calendar/components/content/Article1';
import Article2 from 'calendar/components/content/Article2';
import Article3 from 'calendar/components/content/Article3';
import Article4 from 'calendar/components/content/Article4';
import Article5 from 'calendar/components/content/Article5';
import Article6 from 'calendar/components/content/Article6';
import { fetchContentPage, fetchFrontPageList } from 'shared/redux/actions';
import { content } from 'shared/redux/selectors';

const mapStateToProps = state => ({
  pages: content.getFrontPages(state, { category: 'frontpage-articles' }),
});

const mapDispatchToProps = dispatch =>
  bindActionCreators({ fetchFrontPageList, fetchContentPage }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(
  class ContentContainer extends Component {
    componentDidMount() {
      this.props.fetchFrontPageList();
      this.fetchPages(this.props);
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
      this.fetchPages(nextProps);
    }

    fetchPages(props) {
      const { pages, fetchContentPage } = props;
      pages.forEach(page => fetchContentPage(page.id));
    }

    renderArticle(id, page) {
      const {
        url_alias: urlAlias,
        title,
        body: { und: [{ safe_value: pageBody } = {}] = [] } = {},
      } = page;

      switch (urlAlias) {
        case 'joker__home1':
          return <Article1 key={id} title={title} body={pageBody} />;
        case 'joker__home2':
          return <Article2 key={id} title={title} body={pageBody} />;
        case 'joker__home3':
          return <Article3 key={id} title={title} body={pageBody} />;
        case 'joker__home4':
          return <Article4 key={id} title={title} body={pageBody} />;
        case 'joker__home5':
          return <Article5 key={id} title={title} body={pageBody} />;
        case 'joker__home6':
          return <Article6 key={id} title={title} body={pageBody} />;
        default:
          return null;
      }
    }

    render() {
      const { pages = [] } = this.props;

      return (
        <Fragment>
          {pages.map(({ id, ...page }) => this.renderArticle(id, page))}
        </Fragment>
      );
    }
  },
);
